import endpoints from '@app/src/api/endpoints'
import { FetchKey } from '@app/src/api/fetchHooks'
import Filter from '@app/src/pages/ResourceCollection/Filters/Filter'
import FilterFacetSelect from '@app/src/pages/ResourceCollection/Filters/FilterFacetSelect'
import type { FilterGroup } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { SortOrder } from '@app/src/types/filter'
import React from 'react'
import { useIntl } from 'react-intl'

export const QUESTIONNAIRE_FILTER_NAME = 'sections.questionnaireTemplateId'

// Lets the user narrow questions to those used in one of the organization's questionnaires. Options come
// from a facet on the questions, scoped server-side (QuestionRepository) to questionnaires the
// organization may see.
const QuestionnaireFilter: React.FC<{ implicitFilters?: FilterGroup[] }> = ({ implicitFilters }) => {
  const { formatMessage } = useIntl()

  return (
    <Filter name={QUESTIONNAIRE_FILTER_NAME} operator={Operators.In} uniqueId={QUESTIONNAIRE_FILTER_NAME} intersect>
      {({ value, onChange }) => (
        <FilterFacetSelect
          implicitFilters={implicitFilters}
          size="small"
          multiple
          facetsParam={{
            key: [FetchKey.QuestionFacets, QUESTIONNAIRE_FILTER_NAME],
            endpoint: endpoints.questionWithFacets,
            facetsParam: [{ name: 'sections.questionnaireTemplate.title' }],
            sort: { target: 'label', order: SortOrder.ASCENDING },
          }}
          filterName={QUESTIONNAIRE_FILTER_NAME}
          uniqueId={QUESTIONNAIRE_FILTER_NAME}
          onChange={onChange}
          fieldLabel={formatMessage({ id: 'schemas.question.questionnaires' })}
          value={[value].flat()}
        />
      )}
    </Filter>
  )
}

export default QuestionnaireFilter
